export const FORGE_ENTITY_TYPE = 'FORGE_ENTITY_TYPE' as const;
export const CONNECT_ENTITY_TYPE = 'CONNECT_ENTITY_TYPE' as const;

export const ECOSYSTEM_TYPES = [FORGE_ENTITY_TYPE, CONNECT_ENTITY_TYPE] as const;
